<template>
  <div class="col-12 d-flex justify-content-between mt-4">
    <button
      type="button"
      class="btn btn-secondary"
      v-if="showBackButton"
      @click="$emit('back')"
      :disabled="isLoading"
    >
      <!-- Using previous for consistency -->
      {{ $t("common.back") }}
    </button>
    <button
      v-if="showDoneButton"
      type="button"
      class="btn btn-primary ms-auto"
      @click="$emit('complete')"
      :disabled="isLoading"
    >
      {{ $t("common.done") }}
    </button>
    <!-- Specific for contract review steps -->
    <button
      v-else-if="showSignatureButton"
      type="button"
      class="btn btn-primary ms-auto"
      :disabled="!isStepValid || isLoading"
      @click="$emit('start-signing')"
    >
      {{ $t("signup.navsteps.to_signature_page") }}
    </button>
    <!-- Default "Next" button -->
    <button
      v-else
      type="button"
      class="btn btn-primary ms-auto"
      :disabled="!isStepValid || isLoading"
      @click="$emit('next')"
    >
      {{ $t("common.next") }}
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  showBackButton?: boolean;
  showDoneButton?: boolean;
  showSignatureButton?: boolean;
  isStepValid?: boolean;
  isLoading?: boolean;
}>();

defineEmits<{
  back: [];
  next: [];
  "start-signing": [];
  complete: [];
}>();
</script>
